/* istanbul ignore file */
import DealerspikeV6 from '../platform/dealerspike-v6';

new DealerspikeV6().init();
